import { render, staticRenderFns } from "./UcWorksheetWorkItems.yaml?vue&type=template&id=7fef8212&component"
import script from "./UcWorksheetWorkItems.yaml?vue&type=script&lang=ts&component"
export * from "./UcWorksheetWorkItems.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports